import { useState } from 'react';
import MobileForm, { MobileFormData } from './mobile-form';
import SmsKey from './sms-key';
import RegisterForm from './register-form';
import { CheckSmsKeyRequestReturnType } from '../../api/temp-user';
import { useFormErrorMessage } from '../../hooks/index/use-form-error-message';
import Alert from '../shared/alert';

export type RegisterContentPropsType = {
  startStep?: number;
  defaultMobile?: string | null;
  defaultAuthKey?: string | null;
  noLabel?: boolean;
  onSuccess?: () => void;
  onCancel?: () => void;
};

function RegisterContent({
  startStep = MOBILE,
  defaultMobile = null,
  defaultAuthKey = null,
  noLabel = false,
  onSuccess = async () => {},
  onCancel = () => {}
}: RegisterContentPropsType) {
  const [step, setStep] = useState<number>(startStep);
  const [mobile, setMobile] = useState<string | null>(defaultMobile);
  const [authKey, setAuthKey] = useState<string | null>(defaultAuthKey);
  const { formErrorMessage: errorMessage, setFormError: setError } = useFormErrorMessage();

  if (errorMessage) return <Alert content={errorMessage} />;

  if (step === MOBILE || !mobile) {
    return (
      <MobileForm
        noLabel={noLabel}
        onSubmit={({ mobile }: MobileFormData) => {
          setMobile(mobile);
          setStep(SMS_KEY);
        }}
      />
    );
  }

  if (step === SMS_KEY || !authKey) {
    return (
      <SmsKey
        mobile={mobile}
        noLabel={noLabel}
        onSubmit={({ authKey }: CheckSmsKeyRequestReturnType) => {
          setAuthKey(authKey);
          setStep(REGISTER);
        }}
        onUpdateMobile={() => {
          if (startStep === MOBILE) {
            setStep(startStep);
          } else {
            onCancel();
          }
        }}
        onError={error => {
          setError(error);
          setMobile(null);
          setStep(startStep);
        }}
      />
    );
  }

  if (step === REGISTER) {
    return (
      <RegisterForm
        mobile={mobile}
        authKey={authKey}
        noLabel={noLabel}
        onSuccess={async () => {
          await onSuccess();
          setStep(startStep);
          setMobile(null);
          setAuthKey(null);
        }}
        onCancel={() => {
          setStep(startStep);
          setMobile(null);
          setAuthKey(null);
        }}
      />
    );
  }

  return null;
}

export const [MOBILE, SMS_KEY, REGISTER] = [0, 1, 2];

export default RegisterContent;
